<h2 mat-dialog-title>Crea una nuova chat</h2>
<mat-dialog-content [formGroup]="chatForm">
  <mat-form-field  class="full-width">
    <mat-label>Titolo</mat-label>
    <input matInput placeholder="Enter chat title" formControlName="title">
    <mat-error *ngIf="chatForm.get('title').hasError('required')">
      Il titolo è richiesto
    </mat-error>
  </mat-form-field>

  <div formArrayName="chatUsers">
    <mat-label class="chat-user">Select User</mat-label>
    <div *ngFor="let user of chatUsers.controls; let i = index" [formGroupName]="i" class="chat-user">
      <mat-form-field class="full-width">
        <mat-select formControlName="userId">
          <mat-option [hidden]="userIdInArray(user.value)" *ngFor="let user of usersList" [value]="user.value">
            {{ user.text }} 
          </mat-option>
        </mat-select>
      </mat-form-field>

      <button mat-icon-button color="warn" (click)="removeChatUser(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>

  <button mat-stroked-button color="green" style="color: var(--custom-color)" (click)="addChatUser()">Add User</button>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="green" style="background-color: var(--custom-color); color:white" (click)="save()">Save</button>
</mat-dialog-actions>
